/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
import { useState, useEffect } from 'react'
import { getLocation } from '../utils'

const appendScript = (baseUrl, setScriptLoaded) => {
  if (window.MktoForms2) {
    return setScriptLoaded(true)
  }

  const script = document.createElement('script')
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
  document.body.appendChild(script)
}

const destyleMktoForm = (mktoForm, moreStyles) => {
  const formEl = mktoForm.getFormElem()[0],
    arrayify = getSelection.call.bind([].slice)

  // remove element styles from <form> and children
  const styledEls = arrayify(formEl.querySelectorAll('[style]')).concat(formEl)
  styledEls.forEach(function (el) {
    el.removeAttribute('style')
  })

  // disable remote stylesheets and local <style>s
  const styleSheets = arrayify(document.styleSheets)
  styleSheets.forEach(function (ss) {
    if (
      [mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) !==
        -1 ||
      formEl.contains(ss.ownerNode)
    ) {
      ss.disabled = true
    }
  })

  if (!moreStyles) {
    if (!formEl) {
      return
    }
    formEl.setAttribute('data-styles-ready', 'true')
    formEl.querySelectorAll('.hubspotForm .mktoFormRow').forEach((element) => {
      Array.from(element.children).forEach((child, index) => {
        if (!element) {
          return
        }
        if (element.childNodes.length >= 3) {
          if (!child) {
            return
          }
          child.setAttribute(`data`, `${index}-item`)
        }
      })
    })
    formEl
      .querySelectorAll('.hubspotForm .mktoFormRow select')
      .forEach((element) => {
        if (!element) {
          return
        }
        element.setAttribute('required', 'true')
        Array.from(element.children).forEach((child, index) => {
          if (index === 0) {
            if (!child) {
              return
            }
            child.setAttribute(`selected`, `true`)
            child.setAttribute(`disabled`, `true`)
          }
        })
      })
    formEl.style.display = 'block'
  }
}

const useMarketo = ({ baseUrl, munchkinId, formId, callback, redirect }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [formLoaded, setFormLoaded] = useState(false)
  useEffect(() => {
    if (formLoaded) {
      return
    }
    if (scriptLoaded) {
      window.MktoForms2.loadForm(baseUrl, munchkinId, formId, callback)
      window.MktoForms2.whenRendered((form) => {
        destyleMktoForm(form)
        getLocation().then((response) => {
          form.addHiddenFields({
            visitorState: response.region,
            visitorCountry: response.country_name,
            State: response.region,
          })
          form.onSuccess((values, followUpUrl) => {
            location.href = redirect
            return false
          })
        })
      })
      setFormLoaded(true)
      return
    }
    appendScript(baseUrl, setScriptLoaded)
  }, [
    scriptLoaded,
    formLoaded,
    baseUrl,
    munchkinId,
    formId,
    callback,
    redirect,
  ])
}

export default useMarketo
